import AbstractBaseApi from "@/apis/AbstractBaseApi";
import type { BandWidth, Priority } from "@/apis/CloudVnMsApi";
import type { SaseGatewayRouteAggregation } from "@/apis/SaseGatewayApi";

export interface SaseGatewayResetting {
  /**
   * 総件数（SASEゲートウェイ）
   * 一覧表示対象の総件数
   */
  saseGatewayTotal: number;
  /** 取得した再設定をするSASEゲートウェイ */
  saseGatewayList: SaseGatewayResettingItem[];
}

export interface SaseGatewayResettingItem {
  saseGatewayVnConnectCommon: SaseGatewayVnConnectCommon;
  saseGatewayVnConnectAct: SaseGatewayVnConnectActSby;
  saseGatewayVnConnectSby: SaseGatewayVnConnectActSby;
  maintenance: MaintenanceInfo;
}

export interface SaseGatewayVnConnectCommon {
  /** SASEゲートウェイサービス種別 */
  saseGatewayServiceType: "PALOALTO";
  /**
   * SASEゲートウェイ利用拠点
   * 東日本(EAST_JAPAN)固定
   */
  location: "EAST_JAPAN";
  /** VPN/VNコード */
  vpnVnCode: string;
  /** 仮想ネットワーク(VN)名 */
  vnName: string | null;
  /**
   * 仮想ネットワークタイプ
   * L3固定
   */
  vnType: "L3";
  /**
   * ルーティング種別
   * BGP4固定
   */
  routingType: "BGP4";
  /**
   * 帯域タイプ
   * PF固定
   */
  bandwidthType: "PF";
  /** 帯域 */
  bandwidth: BandWidth;
  /** AS番号 */
  asNumber: number;
  /** Maximum prefix */
  maximumPrefix: number;
  /**
   * 経路集約
   * OFF：経路集約を非表示
   * CUSTOM：経路集約アドレスを入力
   */
  routeAggregation: SaseGatewayRouteAggregation;
  /**
   * 経路集約アドレスリスト
   * 経路集約が「CUSTOM」選択時は必須項目
   */
  routeAggregationAddressList?: string[];
  /** 設定値の説明 */
  description?: string;
}

export interface SaseGatewayVnConnectActSby {
  /** サービスキー(契約番号) */
  serviceKey: string;
  /** VNコネクト名 */
  vnConnectName: string;
  /** W番号 */
  wnumber: string;
  /** Local Preference */
  localPreference: Priority;
  /** MED */
  med: Priority;
}

export interface MaintenanceInfo {
  /** 会社名 */
  company: string;
  /** 部署名 */
  department: string;
  /** 担当者名 */
  name: string;
  /** 電話番号 */
  phone: string;
  /** メールアドレス */
  email: string;
}

/** SASEゲートウェイ再設定API */
export default class SaseGatewayResettingApi extends AbstractBaseApi {
  /**
   * 再設定をするSASEゲートウェイを取得
   */
  async getSaseGatewayResetting(): Promise<SaseGatewayResetting> {
    return (await this.api.get("/v1/network/sasegw/vnconnects/resetting")).data;
  }

  /**
   * SASEゲートウェイを再設定する
   * @param wnumber W番号(ACT回線)
   */
  async postSaseGatewayResetting(wnumber: string): Promise<{ jobId: string }> {
    return (
      await this.api.post(`/v1/network/sasegw/vnconnects/resetting/${wnumber}`)
    ).data;
  }
}
